import { calculateOwaDateTimeFromOffset } from '../utils/owaDateToReminderOffsetConverter';
import { OwaDate, formatWeekDayDateTimeWithAt } from 'owa-datetime';
import {
    ReminderOptionType,
    getAllDayReminderOption,
    getNonAllDayReminderOption,
} from 'owa-calendar-reminder-options';

export default function getDisplayTextFromReminderOffset(
    reminderOffset: number,
    isAllDay: boolean,
    start: OwaDate
): string {
    // 1. Check if the reminderOffset is one of the default remidner option. If so, use the default text of that option, i.e 15 minutes before, etc.
    const reminderOptions: ReminderOptionType[] = isAllDay
        ? getAllDayReminderOption(false /* includeNoReminder */)
        : getNonAllDayReminderOption(false /* includeNoReminder */);

    let reminderDisplayString = null;
    for (let i = 0; i < reminderOptions.length; i++) {
        const reminderOption: ReminderOptionType = reminderOptions[i] as ReminderOptionType;
        if (reminderOption.key === reminderOffset) {
            reminderDisplayString = reminderOption.text;
            break;
        }
    }

    // 2. The reminder offset is not a default option, use customized string
    if (!reminderDisplayString) {
        return getCustomReminderDisplayString(reminderOffset, start);
    }

    return reminderDisplayString;
}

export function getCustomReminderDisplayString(reminderOffset: number, start: OwaDate): string {
    const reminderDate = calculateOwaDateTimeFromOffset(start, reminderOffset);
    return formatWeekDayDateTimeWithAt(reminderDate);
}

export function isReminderOffsetInDefaultOptions(
    reminderOffset: number,
    isAllDay: boolean
): boolean {
    const reminderOptions: ReminderOptionType[] = isAllDay
        ? getAllDayReminderOption(false /* includeNoReminder */)
        : getNonAllDayReminderOption(false /* includeNoReminder */);

    for (let i = 0; i < reminderOptions.length; i++) {
        const reminderOption: ReminderOptionType = reminderOptions[i] as ReminderOptionType;
        if (reminderOption.key === reminderOffset) {
            return true;
        }
    }

    return false;
}
